import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { GatePassPopup } from './GatePassTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class GatePass extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            partyAccountList: [],
            itemRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            gatePassObject: {
                idGatePass: '',
                gatePassNo: '',
                date: '',
                vehicleNo: '',
                personName: "",
                partyName: '',
                partyList: [],
                challanNo: '',
                challanDate: '',
                ref1: '',
                ref2: '',
                updateStatus: '',
                recordStatus: ''
            },
            itemObject: {
                description: "",
                quantity: "",
                weight: "",
                remarks: "",
                index: null
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForGatePass: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                partyName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party"
                        ),
                    },
                ],
            },
            validationRules: {
                description: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                weight: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "weight"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Gate Pass",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idGatePass"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Gate Pass",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "gatePassNo": window.innerWidth * 0.06,
            "date": window.innerWidth * 0.08,
            "party": window.innerWidth * 0.23,
            "vehicleNo": window.innerWidth * 0.08,
            "personName": window.innerWidth * 0.1,
            "challanNo": window.innerWidth * 0.08,
            "challanDate": window.innerWidth * 0.08,
            "ref1": window.innerWidth * 0.08,
            "ref2": window.innerWidth * 0.08,
            "status": window.innerWidth * 0.13,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                }
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.otherFormsServices.getInvoiceCountForGatepass(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let gatePassObject = this.state.gatePassObject
                gatePassObject.gatePassNo = formatted
                this.setState({ gatePassObject: gatePassObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.resetInvoiceItems()
                        this.setState({ itemRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getOtherFormsGatePassByID(event.data.idGatePass);
        let details = this.state.gatePassObject
        details.recordStatus = event.data.status
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            gatePassObject: details
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForGatePass = () => {
        const newValidState = isValidForm(
            this.state.gatePassObject,
            this.state.validationRulesForGatePass,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForGatePass = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.gatePassObject;
        details[name] = value;
        this.setState({ gatePassObject: details });
    }
    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        if (name === 'quantity' || name === 'weight') {
            details.quantity = Number(details.quantity)
            details.weight = Number(details.weight)
        }
        this.setState({ itemObject: details });
    }

    resetDetailsFields = () => {
        let details = this.state.gatePassObject
        details.idGatePass = 0
        details.date = ''
        details.vehicleNo = ''
        details.personName = ''
        details.partyName = 0
        details.challanNo = ''
        details.challanDate = ''
        details.ref1 = ''
        details.ref2 = ''
        details.updateStatus = ''
        details.recordStatus = ''
        this.setState({ gatePassObject: details })
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }

    setFilterParameters = (event, name) => {
        let details = this.state.gatePassObject;
        details[name] = event.value;
        this.setState({ gatePassObject: details });
    }

    insertItem = (key) => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let data = [...this.state.itemRowData];
            let itemObject = this.state.itemObject;
            let itemRowData = {};
            itemRowData.description = itemObject.description;
            itemRowData.quantity = itemObject.quantity;
            itemRowData.weight = itemObject.weight;
            itemRowData.remarks = itemObject.remarks;

            if (itemObject.index !== null && itemObject.index >= 0) {
                data[itemObject.index] = itemRowData;
            } else {
                data.push(itemRowData);
            }
            this.setState({ itemRowData: data }, () => {
                let data = this.state.itemRowData;
                let itemObject = this.state.itemObject

                if (data.length > 0) {
                    this.setState({
                        itemObject: itemObject,
                    }, () => {
                        this.resetInvoiceItems();
                    });
                }
            });
        }
    }

    resetInvoiceItems = () => {
        let details = this.state.itemObject
        details.description = ''
        details.weight = ''
        details.quantity = ''
        details.remarks = ''
        details.index = null
        this.setState({ itemObject: details })
    }

    handleCellClickItemList = (event) => {
        let details = event.data
        let itemObject = this.state.itemObject
        itemObject = details
        itemObject.index = event.rowIndex
        this.setState({ itemObject: itemObject })

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };

    deleteItem = () => {
        let details = this.state.itemObject
        let data = [...this.state.itemRowData];
        data.splice(details.index, 1);
        this.setState({ itemRowData: data }, () => {
            this.resetInvoiceItems();
        })
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFieldsForGatePass();
        if (isValidAllFields) {
            let details = this.state.gatePassObject;
            const isOld = details.updateStatus > 0;
            const isNew = !isOld;
            const isPending = details.recordStatus === 'Pending';
            if (isNew || (isOld && isPending)) {

                let details2 = this.state.itemRowData;
                let gatePassItemList = [];
                details2.map((x) => {
                    let request = {
                        description: x.description,
                        quantity: x.quantity,
                        weight: x.weight,
                        remarks: x.remarks,
                    }
                    gatePassItemList.push(request);
                });
                if (details !== "") {
                    let requestData = {
                        idGatePass: details.idGatePass,
                        gatePassNo: details.gatePassNo,
                        updateStatus: details.updateStatus,
                        date: (details.date && details.date !== 'Invalid date') ? details.date : null,
                        partyName: details.partyName,
                        vehicleNo: details.vehicleNo,
                        personName: details.personName,
                        challanNo: details.challanNo,
                        challanDate: (details.challanDate && details.challanDate !== 'Invalid date') ? details.challanDate : null,
                        ref1: details.ref1,
                        ref2: details.ref2,
                        e_Date: new Date().toISOString(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updatedDate ? details.updatedDate : new Date().toISOString(),
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        idCompany: this.state.idCompany,
                        gatePassItemList: gatePassItemList,
                    }
                    this.otherFormsServices.submitGatePassInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.gatePassObject.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    this.resetDetailsFields();
                                    this.setState(
                                        { isModalOpen: false },
                                        () => {
                                            this.procSelectAllRecordsSP();
                                        }
                                    );
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        });
                }
            } else {
                this.SwalServices.Alert('This record is already processed and can’t be modified.')
            }
        }
    }

    getOtherFormsGatePassByID = (id) => {
        this.otherFormsServices.getOtherFormsGatePassByID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.gatePassObject;
                    data.idGatePass = res.idGatePass;
                    data.gatePassNo = res.gatePassNo;
                    data.updateStatus = 1;
                    data.date = res.date ? moment(res.date).format('YYYY-MM-DD') : "";
                    data.challanDate = res.challanDate ? moment(res.challanDate).format('YYYY-MM-DD') : "";
                    data.vehicleNo = res.vehicleNo;
                    data.personName = res.personName;
                    data.challanNo = res.challanNo;
                    data.partyName = res.partyName;
                    data.ref1 = res.ref1;
                    data.ref2 = res.ref2;
                    this.setState({
                        gatePassObject: data,
                        isModalOpen: true
                    });
                    this.otherFormsServices.getOtherFormsGatePassItemsByID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            let itemObject = this.state.itemObject;
                            let gatePassItemList = [];
                            if (value.length > 0) {
                                value.map((x) => {
                                    let request = {
                                        description: x.description,
                                        quantity: x.quantity,
                                        weight: x.weight,
                                        remarks: x.remarks,
                                    }
                                    gatePassItemList.push(request);
                                });
                                if (gatePassItemList.length > 0) {
                                    this.setState({
                                        itemRowData: gatePassItemList,
                                    }, () => {
                                        this.resetInvoiceItems();
                                    });
                                }
                                this.setState({ itemObject: itemObject });
                            }
                        }
                    });

                }
            }
        });
    }

    render() {
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <GatePassPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            gatePassObject={this.state.gatePassObject}
                            itemObject={this.state.itemObject}
                            handleChangeForGatePass={this.handleChangeForGatePass.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            // submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}

                            partyAccountList={this.state.partyAccountList}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            submit={this.submit.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Manually Invoice</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
